export const basicFields = `
  numberOfEmployees
  name
`
